import { EntityList, entityList } from '@vromo/models';

import { Job } from '@vromo/models';
import { Vehicle } from '@vromo/models';
import { createModelSchema } from 'serializr';

export default class TrackingLinkStore {
    jobs = new EntityList(Job);
    vehicles = new EntityList(Vehicle);
}

createModelSchema(TrackingLinkStore, {
    jobs: entityList(Job),
    vehicles: entityList(Vehicle)
});
